<template>
<div id="hotel-description">
    <v-card flat class="pa-sm-3">
        <v-card-text>
            <div class="important font-weight-bold px-2">{{ $t('hotel.contact.title') }}</div>
            <v-form v-model="valid" ref="hotel_contact">
                <v-row>
                    <v-col md="5" cols="12" class="py-0">
                        <v-text-field :label="$t('hotel.contact.website')" v-model="item.static.defaults.website" />
                    </v-col>
                    <v-col md="5" cols="12" class="py-0">
                        <v-text-field :label="$t('hotel.contact.email')" v-model="item.email" required :rules="rules.email" />
                    </v-col>
                    <v-col md="5" cols="12" class="py-0">
                        <v-text-field :label="$t('hotel.contact.phone')" v-model="item.static.defaults.phone" required :rules="rules.phone" />
                    </v-col>
                    <v-col md="5" cols="12" class="py-0">
                        <v-text-field :label="$t('hotel.contact.fax')" v-model="item.static.defaults.fax" />
                    </v-col>
                </v-row>

                <v-divider class="mb-3" />
                <div>
                    <div class="important font-weight-bold px-2">{{$t('hotel.contact.title_contact_person')}}</div>
                    <v-row>
                        <v-col md="5" cols="12" class="py-0">
                            <v-text-field :label="$t('hotel.contact.person_name')" v-model="item.static.contact.person" required :rules="rules.name" />
                        </v-col>
                        <v-col md="5" cols="12" class="py-0">
                            <v-text-field :label="$t('hotel.contact.person_email')" v-model="item.static.contact.email" required :rules="rules.email" />
                        </v-col>
                        <v-col md="5" cols="12" class="py-0">
                            <v-text-field :label="$t('hotel.contact.person_position')" v-model="item.static.contact.position" />
                        </v-col>
                        <v-col md="5" cols="12" class="py-0">
                            <v-text-field :label="$t('hotel.contact.person_phone')" v-model="item.static.contact.phone" required :rules="rules.phone" />
                        </v-col>
                    </v-row>
                </div>
            </v-form>
        </v-card-text>
    </v-card>
</div>
</template>

<script>
import {
    mapActions
} from 'vuex';

export default {
    props: {
        item: Object,
        config: Object,
        active: Object
    },
    name: `hotel-contact`,
    components: {},
    data() {
        return {
            valid: false,
        };
    },

    watch: {
        plans_selected: {
            handler() {
                this.$emit('updateRatePlan', this.plans_selected);
            }
        },
        valid: {
            handler() {
                this.$emit('validate', [1, this.valid]);
            }
        },
    },

    computed: {
        status() {
            if(this.active.validate == false) {
                this.$nextTick(() => {
                    this.$refs.hotel_contact.validate();
                })
            }
            return this.active.validate
        },
        rules() {
            return {
                name: [v => !!v || this.$t('hotel.contact.form_rules.name')],
                phone: [v => !!v || this.$t('hotel.contact.form_rules.phone')],
                email: [
                    v => !!v || this.$t('hotel.contact.form_rules.email'),
                    v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || this.$t('hotel.contact.form_rules.email_valid')
                ]
            }
        }
    },

    methods: {

        ...mapActions('alert', ['success', 'error']),

    },

};
</script>

<style lang="stylus">
.weekend-days .v-btn
    min-width: 55px
</style>
